export enum EntityTypes {
  ENT_DIVISION = 'ENT_DIVISION',
  ENT_BRAND = 'ENT_BRAND',
}

export enum FeatureTypes {
  FEA_WORKSPACE_MAIN = 'feaWorkspaceMain',
  FEA_CAMPAIGN_MAIN = 'feaCampaignMain',
  FEA_CAMPAIGN_TIMELINE = 'feaCampaignTimeline',
  FEA_CAMPAIGN_ASSETLIST = 'feaCampaignAssetlist',
  FEA_PROJECT_MAIN = 'feaProjectMain',
  FEA_PROJECT_SECTION = 'feaProjectSection',
}

export enum FeatureCriteriaForm {
  CRITERIA_FORM_TIMELINE_1 = 'CRITERIA_FORM_TIMELINE_1',
  CRITERIA_FORM_TIMELINE_2 = 'CRITERIA_FORM_TIMELINE_2',
  CRITERIA_FORM_ASSETLIST_1 = 'CRITERIA_FORM_ASSETLIST_1',
  CRITERIA_FORM_TIMELINE_SIMPLIFIED_1 = 'CRITERIA_FORM_TIMELINE_SIMPLIFIED_1',
  CRITERIA_FORM_ASSETLIST_SIMPLIFIED_1 = 'CRITERIA_FORM_ASSETLIST_SIMPLIFIED_1',
  CRITERIA_FORM_TIMELINE_SIMPLIFIED_2 = 'CRITERIA_FORM_TIMELINE_SIMPLIFIED_2',
  CRITERIA_FORM_ASSETLIST_SIMPLIFIED_2 = 'CRITERIA_FORM_ASSETLIST_SIMPLIFIED_2',
}

export interface FeatureConfig {
  active: true;
}

export interface FeatureConfigResult {
  entityType: EntityTypes;
  entityId: string;
  features: Record<FeatureTypes, FeatureConfig>;
}

export interface WorkspaceFeatureConfig extends FeatureConfig {}

export interface CampaignMainFeatureConfig extends FeatureConfig {
  campaignName: string;
  hasLeader: boolean;
  hasCncManager: boolean;
  hasProductDevManager: boolean;
  editCampaignReplaceTimeline: boolean;
  hasMagellanNumber: boolean;
  hasProductName: boolean;
  activeProduct: boolean;
  reportingType: string;
}

export interface CampaignTimelineFeatureConfig extends FeatureConfig {
  autoCalculateMilestoneStatus: string;
  criteriaForm: string;
  hasSimulator: boolean;
  datasetName: string;
  hasNegotiatedDate: boolean;
  madLabel: string;
  madxLabel: string;
}

export interface CampaignAssetListFeatureConfig extends FeatureConfig {
  datasetName: string;
  criteriaForm: string;
  funnel: string[];
  platform: string[];
  format: string[];
  focus: string[];
  type: string[];
  length: string[];
  region: string[];
  agency: string[];
  category: string[];
}

export interface CampaignFeatureConfig {
  hasSimulator: boolean;
  headerLabel: string | null;
  linksLabel: string | null;
  newCampaignLabel: string | null;

  isStandAloneSearchEnabled: boolean;
  isCriteriaForm1Enabled: boolean;
  isCriteriaForm2Enabled: boolean;
  isCriteriaFormTimelineSimplified1Enabled: boolean;

  hasCncManager: boolean;
  hasProductDevManager: boolean;
  hasActiveProduct: boolean;
  isWorkspaceEnabled: boolean;
}
